module.exports = __webpack_public_path__ + "img/About_7.38225e49.png";